"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof")),
    _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _memoizeOne2 = _interopRequireDefault(require("memoize-one")),
    _getDisplayBytes = _interopRequireDefault(require("@devsta/get-display-bytes")),
    _uiKit = require("@devsta/ui-kit"),
    _utils = require("../../common/utils");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var LABELS_MAP = {
  ORIGINAL: "Original Quality",
  HD: "High Resolution",
  SD: "Low Resolution",
  CAPTION: "Caption",
  VTT_CAPTION: "VTT Caption"
},
    CAPTION_TYPES = ["CAPTION", "VTT_CAPTION"],
    isCaption = function isCaption(a) {
  return CAPTION_TYPES.includes(a);
},
    isAssetFileValid = function isAssetFileValid(a) {
  var b = a.type,
      c = a.metaData;
  return !!LABELS_MAP[b] && (!isCaption(b) || c && c.lang);
},
    getFileDetails = (0, _lodash["default"])(function (a) {
  if (!a) return "";
  var b = a.type,
      c = a.size,
      d = b && b.split("/").pop(),
      e = c && (0, _getDisplayBytes["default"])(c);
  return [d, e].filter(Boolean).join(" | ");
}),
    getOptionValues = function getOptionValues(a, b) {
  var c = a.type,
      d = a.metaData;
  return isCaption(c) ? {
    details: getFileDetails(d),
    label: "".concat(LABELS_MAP[c], " - ").concat(d.lang && d.lang.toUpperCase()),
    onClick: function onClick() {
      return (0, _utils.downloadFile)({
        assetId: b,
        assetFiles: "".concat(c, "_").concat(d.lang.toUpperCase())
      });
    }
  } : {
    label: LABELS_MAP[c],
    onClick: function onClick() {
      return (0, _utils.downloadFile)({
        assetId: b,
        assetFiles: c
      });
    },
    details: getFileDetails(d)
  };
},
    DownloadAssetMenu = function (a) {
  function b() {
    var a, d;
    (0, _classCallCheck2["default"])(this, b);

    for (var e = arguments.length, f = Array(e), g = 0; g < e; g++) {
      f[g] = arguments[g];
    }

    return (0, _possibleConstructorReturn2["default"])(d, (a = d = c.call.apply(c, [this].concat(f)), d.getDownloadOptions = (0, _memoizeOne2["default"])(function (a) {
      return a && a.assetFiles ? (0, _toConsumableArray2["default"])(Object.keys(a.assetFiles)).filter(function (b) {
        return a.assetFiles[b] && (Array.isArray(a.assetFiles[b]) || "object" === (0, _typeof2["default"])(a.assetFiles[b]));
      }).reduce(function (b, c) {
        return isCaption(c) && Array.isArray(a.assetFiles[c]) ? [].concat((0, _toConsumableArray2["default"])(b), (0, _toConsumableArray2["default"])(a.assetFiles[c])) : [].concat((0, _toConsumableArray2["default"])(b), [a.assetFiles[c]]);
      }, []).map(function (a) {
        if (!a.metaData) return a;

        try {
          var b = JSON.parse(a.metaData);
          return _objectSpread(_objectSpread({}, a), {}, {
            metaData: b
          });
        } catch (b) {
          return a;
        }
      }).filter(isAssetFileValid).map(function (b) {
        return getOptionValues(b, a.assetId);
      }) : null;
    }), a));
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.children,
          c = a.asset,
          d = a.disabled,
          e = this.getDownloadOptions(c);
      return !d && e && e.length ? _react["default"].createElement(_uiKit.ActionPopup, {
        options: e.map(function (a) {
          var b = a.label,
              c = a.onClick,
              d = a.details;
          return {
            action: c,
            label: _react["default"].createElement("div", null, _react["default"].createElement(_uiKit.Text, {
              noMargin: !0
            }, b), _react["default"].createElement(_uiKit.Text, {
              caption: !0,
              noMargin: !0
            }, d))
          };
        }),
        popupBtn: b
      }) : b;
    }
  }]), b;
}(_react.Component);

exports["default"] = DownloadAssetMenu;